import styled from 'styled-components';
import {
  supportLemonGreen,
  brandBlack,
  supportOliveGreen,
  supportDarkGreen,
  neutralBlueGray
} from 'src/utilities/UIStyles/variables/Colors';
import { device } from 'src/utilities/UIStyles/variables/breakpoints';

export const TermsContainer = styled.div`
  font-family: 'IBM Plex Sans', sans-serif;
  margin: 5% 3%;
  border-radius: 5px;
  opacity: 0.8;
  padding: 1% 3%;
  & > p {
    margin: 0;
    color: black;
    font-size: 1vw;
    & > a {
      color: ${supportOliveGreen};
      font-weight: bold;
    }
    & > span {
      color: ${supportOliveGreen};
      font-weight: bold;
    }
  }
  & > h2 {
    color: ${neutralBlueGray};
    font-weight: 600;
    font-size: 1.2vw;
    margin: 2% 0;
  }
  & > h1 {
    color: ${supportLemonGreen};
    text-align: center;
    font-weight: 700;
    margin: 0 3%;
    padding: 2% 0;
  }
  & > h3 {
    color: ${supportDarkGreen};
    margin: 2% 0;
    font-weight: 600;
  }
  & > h4 {
    color: ${supportOliveGreen};
    margin: 2%;
    font-weight: 600;
  }
  & > ul {
    padding: 2% 5%;
    font-size: 1vw;
    & > p {
      color: ${neutralBlueGray};
      padding: 0;
      font-weight: bold;
      font-size: 1vw;
    }
    & > li {
      font-size: 1vw;
      & > span {
        color: ${brandBlack};
        text-align: center;
        font-weight: 600;
        font-size: 1.1vw;
      }
    }
  }
`;

export const Logo = styled.div`
  display: flex;
  width: 100%;
  margin: 1% 0 0 80%;
`;
////////////////
export const TableContainer = styled.section`
  display: flex;
  margin-bottom: 5%;
  padding-top: 5%;
  display: flex;
  flex-direction: column;
  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const TableOne = styled.table`
  margin: auto;
  margin-top: 5%; // borrar
  width: 50%;
  border-collapse: collapse;

  > thead {
    background-color: #6eac46;
    border: 1.5px solid #6eac46;

    > tr {
      > th {
        padding: 2%;
      }
    }
  }

  > tbody {
    > tr {
      > td {
        font-weight: bold;
        padding: 1%;
        border: 1.5px solid #6eac46;
      }

      > td:nth-child(1) {
        padding-left: 3%;
      }

      > td:nth-child(2) {
        text-align: center;
      }
    }

    > tr:nth-child(odd) {
      background-color: #e0edd9;
    }
  }
`;

export const TableTwo = styled.table`
  margin: auto;
  margin-top: 5%; // borrar
  width: 30%;
  border-collapse: collapse;

  > thead {
    background-color: #6eac46;
    border: 1.5px solid #6eac46;

    > tr {
      > th {
        padding: 2%;
      }
    }
  }

  > tbody {
    > tr {
      > td {
        font-weight: bold;
        text-align: center;
        border: 1.5px solid #6eac46;
      }

      > td:nth-child(1) {
        padding-left: 3%;
      }

      > td:nth-child(2) {
        text-align: center;
      }
    }

    > tr:nth-child(odd) {
      background-color: #e0edd9;
    }
  }
`;
